import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiRequest } from "@shared/services/api/apiRequest";
import { PhaseActionStatusType } from "../types/platform.types";

export type Args = {
  userPhaseActionId: number;
  status: PhaseActionStatusType;
  onDone?: () => Promise<void>;
};

export function useUpdateUserPhaseActionStatus({
  userPhaseActionId,
  status,
  onDone,
}: Args) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      return await apiRequest("/api/update-user-action/", "POST", {
        upa_id: userPhaseActionId,
        status,
      });
    },
    onError: (error: Error) => {
      throw error;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["user-phase-actions"],
      });

      await onDone?.();
    },
  });
}

export default useUpdateUserPhaseActionStatus;
